import { render, staticRenderFns } from "./patientHistoryType.vue?vue&type=template&id=6797e5f1&"
import script from "./patientHistoryType.vue?vue&type=script&lang=js&"
export * from "./patientHistoryType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports